import React from 'react';
import { Container } from 'react-bootstrap';
import ClientesInativos from './ClientesInativos';
import './DashboardBling.css';

const DashboardBling = () => {
    return (
        <Container fluid className="px-4 py-4 dashboard-bling-container fade-in">
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">
                <div>
                    <h2 className="mb-0 text-primary fw-bold">Recuperação de Clientes</h2>
                </div>
            </div>

            <ClientesInativos />
        </Container>
    );
};

export default DashboardBling;
